module.exports = __webpack_public_path__ + "static/media/flagOrange.1dd71885.svg";